declare const window:any;
export const deleteObjectStateFunc:Function = function(dataObj:any){
    const run:Function = function(data:any) {
        let $ = window.jQuery;
        if (typeof (data) != "object") {
            return false;
        }
        if ($.isArray(data)) {
            for (let i = 0; i < data.length; i++) {
                if (typeof (data[i]) == "object") {
                    run(data[i]);
                }
            }
        } else {
            if(!$.isEmptyObject(data)){
                delete data.objectState;
                for (let key in data) {
                    if (typeof (data[key]) == "object") {
                        run(data[key]);
                    }
                }
            }
        }
    }
    run(dataObj);
}